export enum AccountingMigrationExternalSystem {
    QUICKBOOKS_ONLINE = "QuickBooks Online",
    QUICKBOOKS_ONLINE_GL_COA = "QuickBooks Online (GL + CoA)",
    QUICKBOOKS_DESKTOP = "QuickBooks Desktop",
    INTUIT_ENTERPRISE_SUITE = "Intuit Enterprise Suite",
    XERO = "Xero",
    DIGITS = "Digits",
    PUZZLE = "Puzzle",
    BENCH = "Bench",
    BALANCE_SHEET_IMPORT = "Balance Sheet Import",
    COA_IMPORT = "CoA Import",
    API = "API",
}

export enum AccountingMigrationChartImportMode {
    MAPPED = "mapped",
    AS_IS = "as_is",
}

export enum ImportedAttachmentTargetType {
    VENDOR = "vendor",
    CUSTOMER = "customer",
    JOURNAL_ENTRY = "journalEntry",
    BILL = "bill",
    INVOICE = "invoice",
    OTHER = "other",
}

export enum MigratedJeDescriptionNormalizationStatus {
    PENDING = "pending",
    DONE = "done",
    FAILED = "failed",
}

export function isCoaImportMigration(
    externalSystem: AccountingMigrationExternalSystem | null,
): boolean {
    return externalSystem === AccountingMigrationExternalSystem.COA_IMPORT;
}

export function isApiMigration(
    externalSystem: AccountingMigrationExternalSystem | null | undefined,
): externalSystem is AccountingMigrationExternalSystem.API {
    return externalSystem === AccountingMigrationExternalSystem.API;
}

export function isQuickBooksDesktopExternalSystem(
    externalSystem: AccountingMigrationExternalSystem | null | undefined,
): externalSystem is AccountingMigrationExternalSystem.QUICKBOOKS_DESKTOP {
    return (
        externalSystem === AccountingMigrationExternalSystem.QUICKBOOKS_DESKTOP
    );
}

// The object types a customer picks when starting a migration. Each maps to
// exactly one `sync*` column and one importer; the chart of accounts is
// deliberately absent because it is derived from the other choices rather than
// picked.
export enum MigrationObjectType {
    GENERAL_LEDGER = "generalLedger",
    COUNTERPARTIES = "counterparties",
    ATTACHMENTS = "attachments",
    CLASSES = "classes",
    CATALOG_ITEMS = "catalogItems",
    INVOICES = "invoices",
    BILLS = "bills",
}
